import type {MemberInfo} from 'src/openapi/admin/models/MemberInfo';

export const shouldAddToMembers = (
    addedMembers: Array<MemberInfo>,
    memberIds: Array<number>,
    item: MemberInfo,
): boolean => {
    if (item.userId && memberIds.includes(item.userId)) {
        return false;
    }

    return !addedMembers.map(w => w.email).includes(item.email);
};

export const splitQuery = (query: string): Array<string> => {
    return [...new Set(query
        .replaceAll(/(?:\n)/g, ' ')
        .replaceAll(/(?:\t)/g, ' ')
        .replaceAll(/(?:\r)/g, ' ')
        .replaceAll(';', ' ')
        .replaceAll(',', ' ')
        .split(' ')
        .map(e => e.trim())
        .filter(e => e.length),
    )];
};
